import React from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { Modal, Row, Col, Button, Typography, Space } from 'antd';
import moment from 'moment';
import { lessonsApi } from '@/api/lessons/lessonsApi';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next'; // Added import

const { Text } = Typography;

const ScheduledLessonModalComponent = ({ isVisible, onClose, selectedEvent }) => {
    const { t } = useTranslation(); // Added hook
    const { user } = useSelector((state) => state.profile);
    const { authData } = useSelector((state) => state.auth);
    const handleJoinMeeting = () => {
        lessonsApi
            .joinMeeting({
                id: selectedEvent?.extendedProps?.id,
                studentId: user?.id
            })
            .then((res) => {
                const meetingLink = res?.data?.data?.link;
                if (meetingLink) {
                    window.open(meetingLink, '_blank', 'noopener,noreferrer');
                }
            })
            .catch((err) => console.error(err));
    };

    return (
        <Modal
            title={t('Dashboard_Event_Modal_Title')}
            open={isVisible}
            onCancel={onClose}
            footer={[
                <Button
                    key="close"
                    onClick={onClose}>
                    {t('Dashboard_Event_Modal_Button_Close')}
                </Button>,
                selectedEvent?.extendedProps?.link && authData?.roles[0]?.name !== 'Admin' && (
                    <Button
                        key="join"
                        onClick={() => handleJoinMeeting()}
                        rel="noopener noreferrer"
                        type="primary">
                        {t('Dashboard_Event_Modal_Button_Join')}
                    </Button>
                )
            ]}
            width={600}>
            {selectedEvent && (
                <div
                    className="event-details"
                    style={{ paddingTop: '12px' }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Space
                                direction="vertical"
                                size="large"
                                style={{ width: '100%' }}>
                                <Text>
                                    <Text type="secondary">
                                        {t('Dashboard_Event_Modal_Label_Course')}:{' '}
                                    </Text>
                                    {selectedEvent.extendedProps?.courseName}
                                </Text>
                                <Text>
                                    <Text type="secondary">
                                        {t('Dashboard_Event_Modal_Label_Description')}:{' '}
                                    </Text>
                                    {selectedEvent.extendedProps?.description}
                                </Text>
                            </Space>
                        </Col>
                        <Col span={12}>
                            <Space
                                direction="vertical"
                                size="large"
                                style={{ width: '100%' }}>
                                <Text>
                                    <Text type="secondary">
                                        {t('Dashboard_Event_Modal_Label_Start')}:{' '}
                                    </Text>
                                    {moment(selectedEvent.start).format('YYYY-MM-DD HH:mm')}
                                </Text>
                                <Text>
                                    <Text type="secondary">
                                        {t('Dashboard_Event_Modal_Label_End')}:{' '}
                                    </Text>
                                    {moment(selectedEvent.end).format('YYYY-MM-DD HH:mm')}
                                </Text>
                                <Text>
                                    <Text type="secondary">
                                        {t('Dashboard_Event_Modal_Label_Duration')}:{' '}
                                    </Text>
                                    {moment(selectedEvent.end).diff(
                                        moment(selectedEvent.start),
                                        'minutes'
                                    )}{' '}
                                    {t('Dashboard_Event_Modal_Label_Minutes')}
                                </Text>
                            </Space>
                        </Col>
                    </Row>
                </div>
            )}
        </Modal>
    );
};

ScheduledLessonModalComponent.displayName = 'ScheduledLessonModal';

const ScheduledLessonModal = (props) => {
    return (
        <ErrorWrapper>
            <ScheduledLessonModalComponent
                data-id="ScheduledLessonModal-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default ScheduledLessonModal;
